import loginAppUrl from 'config/login';

class FederatedIdProvider {
    constructor(name) {
        this.name = name;
    }

    setUrlWithParameters(
        domain,
        redirect_uri,
        response_type,
        client_id,
        identity_provider,
        scopes
    ) {
        const queryString = Object.entries({
            client_id: client_id,
            response_type: response_type,
            //state: Math.random(),
            redirect_uri: redirect_uri,
            identity_provider: identity_provider,
            scopes: scopes,
        })
            //.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
            .map(([k, v]) => `${k}=${v}`)
            .join('&');

        this.url = `https://${domain}.auth.us-west-2.amazoncognito.com/oauth2/authorize?${queryString}`;
    }

    hasIdProvider = (info) => {
        if (typeof info['nextcloudIdentityProvider'] === 'undefined') {
            return false;
        }

        if (info['nextcloudIdentityProvider'] === null) {
            return false;
        }

        return true;
    };

    getIdProvider = (info) => {
        if (this.hasIdProvider(info) === true) {
            return info['nextcloudIdentityProvider'];
        }
        return null;
    };

    getAuthorizeUrl = (loginProfile) => {
        // const provider = this.getIdProvider(info);
        // return provider.url;

        let client_id = loginProfile['appClientId'];
        let domain = loginProfile['cognitoUserPoolDomain'];
        let redirect_uri = loginAppUrl;
        let response_type = 'code';

        let identity_provider = 'Panasonic.aero';
        let scopes = [];

        if (typeof loginProfile['nextcloudIdentityProvider'] !== 'undefined') {
            identity_provider = loginProfile['nextcloudIdentityProvider'].name;
            scopes = loginProfile['nextcloudIdentityProvider'].scopes;
        }

        const queryString = Object.entries({
            client_id: client_id,
            response_type: response_type,
            //state: Math.random(),
            redirect_uri: redirect_uri,
            identity_provider: identity_provider,
            scopes: scopes,
        })
            .map(([k, v]) => `${k}=${v}`)
            .join('&');

        let url = `https://${domain}.auth.us-west-2.amazoncognito.com/oauth2/authorize?${queryString}`;
        return url;
    };
}

export default FederatedIdProvider;
